module.exports = __webpack_public_path__ + "img/avatar.49587c2d.jpeg";